import * as types from './types';

const result = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};

export const setValues = (payload) => result(types.SET_VALUES, payload);
